import type React from 'react';
import { cn } from '@/lib/utils';

/** Второй уровень шапки на телефоне: тонкая липкая полоса под основной шапкой
 *  с управлением страницы (день/неделя и даты в Отчёте, вкладки и период в
 *  Статистике). Одна высота и один вид на всех страницах; содержимое обязано
 *  помещаться — без горизонтальной прокрутки полосы (Алексей 17.09, AI12.7,
 *  AI12.9). На компьютере не рендерится: там управление в основной шапке. */
export function MobileSubHeader({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'sticky top-0 z-20 flex h-11 shrink-0 items-center gap-2 border-b border-border bg-background/95 px-2 backdrop-blur md:hidden',
        className,
      )}
    >
      {children}
    </div>
  );
}
